import { render } from "./OptionsMenu.vue?vue&type=template&id=8205a784&scoped=true"
import script from "./OptionsMenu.vue?vue&type=script&lang=js"
export * from "./OptionsMenu.vue?vue&type=script&lang=js"

import "./OptionsMenu.vue?vue&type=style&index=0&id=8205a784&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8205a784"]])

export default __exports__